import React, { useEffect, useState } from 'react';
import Echo from 'laravel-echo';
import { useDispatch } from 'react-redux';
import { Route, Switch, useRouteMatch, useHistory } from 'react-router-dom';

import { post } from '../../lib/requests';
import { apiHost } from '../../config';
import getEchoConfig from '../../lib/getEchoConfig';

import getAllStudents from '../../lib/apiClient/students/getAll';
import getAllGrades from '../../lib/apiClient/grades/getAll';
import getAllStudentsResults from '../../lib/apiClient/studentsResults/getAll';
import handleUnauthorized from '../../lib/handleUnauthorized';

import subscribeToStudentsChannel from '../../lib/socketClient/students';

import Navbar from '../../components/common/Navbar/Navbar';
import SidePanel from '../../components/common/SidePanel/SidePanel';
import LoginForm from '../../components/common/LoginForm/LoginForm';

import StudentsPage from './students/index';
import ImportsPage from './imports/index';

import { setAllStudents } from '../../redux/reducers/StudentsReducer';
import { setAllGrades } from '../../redux/reducers/GradesReducer';
import { setAllStudentsResults } from '../../redux/reducers/StudentsResultsReducer';

import styles from '../admin/Layout.module.scss';

const TeacherPage = () => {
  const match = useRouteMatch();
  const history = useHistory();
  const dispatch = useDispatch();

  const [authorized, setAuthorized] = useState<boolean | undefined>(undefined);

  const sidePanelTabs = [
    { label: 'Ученики', href: '/teacher/students' },
    { label: 'Импорт / экспорт учеников', href: '/teacher/imports' },
  ];

  const unauthorizedCallback = () => setAuthorized(false);

  const loadData = () => {
    getAllStudents()
      .then((response) => {
        dispatch(setAllStudents(response.rows));
      })
      .catch(handleUnauthorized(unauthorizedCallback));

    getAllGrades()
      .then((response) => {
        dispatch(setAllGrades(response.rows));
      })
      .catch(handleUnauthorized(unauthorizedCallback));

    getAllStudentsResults()
      .then((response) => {
        dispatch(setAllStudentsResults(response.rows));
      })
      .catch(handleUnauthorized(unauthorizedCallback));
  };

  const checkIfUserIsTeacher = () => {
    post(`${apiHost}/api/middleware/check_if_user_is_teacher`, {})
      .then(({ schoolId }) => {
        setAuthorized(true);
        loadData();

        const echo = new Echo(getEchoConfig());
        echo.connect();

        subscribeToStudentsChannel(schoolId, echo, dispatch);
      })
      .catch(() => history.push('/login'));
  };

  useEffect(checkIfUserIsTeacher, []);

  if (authorized === undefined) return null;

  return (
    <>
      <Navbar />

      <SidePanel tabs={sidePanelTabs} />

      <div className={styles.admin_page_layout__main_container}>
        <Switch>
          <Route path={`${match.url}/students`}>
            <StudentsPage unauthorizedCallback={unauthorizedCallback} />
          </Route>

          <Route path={`${match.url}/imports`} exact>
            <ImportsPage unauthorizedCallback={unauthorizedCallback} />
          </Route>
        </Switch>
      </div>

      {!authorized && (
        <LoginForm
          onSuccess={({ role }) => {
            if (role !== 2) {
              throw new Error('Войдите под учетной записью учителя');
            }

            setAuthorized(true);
            loadData();
          }}
        />
      )}
    </>
  );
};

export default TeacherPage;
